var slickInit;

const selectors = {
	'largeBannerSlider': '[data-banner-slider]',
	'imagesSectionSlider': '[data-images-slider]',
	'caseStudiesSlider': '[data-case-studies-slider]',
	'testimonialsSlider': '[data-testimonials-slider]',
	'prevArrow': '[data-prev-arrow]',
	'nextArrow': '[data-next-arrow]',
};

(function ($) {

	slickInit = function () {
		// new SlickSlider('.c-references', {
		// 	// fade: true,
		// 	autoplay: true,
		// 	autoplaySpeed: 5000,
		// 	speed: 1000,
		// 	arrows: true,
		// 	pauseOnHover: false,
		// 	dots: false,
		// 	loop: true,
		// 	mobileFirst: true,
		// 	prevArrow: '.c-references__arrow--prev',
		// 	nextArrow: '.c-references__arrow--next',
		// 	responsive: [
		// 		{
		// 			breakpoint: 600 - 1,
		// 			settings: {
		// 				slidesToShow: 2
		// 			}
		// 		},
		// 		{
		// 			breakpoint: 900 - 1,
		// 			settings: {
		// 				slidesToShow: 3
		// 			}
		// 		},
		// 	],
		// 	events: {
		// 		init: function (e, slick) {
		// 			setTimeout(_ => {
		// 				slick.$slides.eq(0).addClass('is-in-view');
		// 			}, 10);
		// 		},
		// 		beforeChange: function (e, slick, currentSlide, nextSlide) {
		// 			slick.$slides.eq(nextSlide).addClass('is-in-view');
		// 		},
		// 		afterChange: function (e, slick, currentSlide) {
		// 			slick.$slides.not(':eq(' + currentSlide + ')').removeClass('is-in-view');
		// 		}
		// 	}
		// });

		$(selectors.largeBannerSlider).each((i, slider) => {

			const $slider = $(slider);

			new SlickSlider(slider, {
				// fade: true,
				autoplay: true,
				autoplaySpeed: 5000,
				speed: 1000,
				arrows: false,
				pauseOnHover: false,
				dots: false,
				loop: true,
				fade: true,
				mobileFirst: true,
				slidesToShow: 1,
				rows: 0,
			});

		});

		$(selectors.imagesSectionSlider).each((i, slider) => {

			const $slider = $(slider);
			const per_page = parseInt($slider.attr('data-per-page'));
			const num_slides = $slider.children().length;

			var $args = {
				// fade: true,
				// autoplay: true,
				autoplaySpeed: 5000,
				speed: 1000,
				arrows: true,
				pauseOnHover: false,
				dots: false,
				loop: true,
				rows: 0,
				mobileFirst: true,
				slidesToShow: 1,
				prevArrow: $(selectors.prevArrow, $slider.closest('section')),
				nextArrow: $(selectors.nextArrow, $slider.closest('section')),
				responsive: [
					{
						breakpoint: 600 - 1,
						settings: {
							slidesToShow: Math.ceil(per_page / 2),
						}
					},
				]
			};

			if (num_slides <= per_page) {
				$args['responsive'].push({
					breakpoint: 900 - 1,
					settings: 'unslick'
				});
			}
			else {
				$args['responsive'].push({
					breakpoint: 900 - 1,
					settings: {
						slidesToShow: per_page,
					}
				});
			}

			new SlickSlider(slider, $args);

		});

		$(selectors.caseStudiesSlider).each((i, slider) => {

			const $slider = $(slider);

			new SlickSlider(slider, {
				// fade: true,
				// autoplay: true,
				autoplaySpeed: 5000,
				speed: 1000,
				arrows: true,
				pauseOnHover: false,
				dots: false,
				loop: true,
				rows: 0,
				mobileFirst: true,
				slidesToShow: 1,
				prevArrow: $(selectors.prevArrow, $slider.closest('section')),
				nextArrow: $(selectors.nextArrow, $slider.closest('section')),
				responsive: [
					{
						breakpoint: 600 - 1,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 900 - 1,
						settings: {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 1200 - 1,
						settings: {
							slidesToShow: 4,
						}
					},
					{
						breakpoint: 1400 - 1,
						settings: 'unslick'
					},
				]
			});

		});

		$(selectors.testimonialsSlider).each((i, slider) => {

			const $slider = $(slider);
			const per_page = 2;
			const num_slides = $slider.children().length;

			var $args = {
				// fade: true,
				// autoplay: true,
				autoplaySpeed: 5000,
				speed: 1000,
				arrows: true,
				pauseOnHover: false,
				dots: false,
				loop: true,
				rows: 0,
				mobileFirst: true,
				slidesToShow: 1,
				prevArrow: $(selectors.prevArrow, $slider.closest('section')),
				nextArrow: $(selectors.nextArrow, $slider.closest('section')),
				responsive: []
			};

			if (num_slides <= per_page) {
				$args['responsive'].push({
					breakpoint: 900 - 1,
					settings: 'unslick'
				});
			}
			else {
				$args['responsive'].push({
					breakpoint: 900 - 1,
					settings: {
						slidesToShow: per_page,
					}
				});
			}

			new SlickSlider(slider, $args);

		});


	}

	class SlickSlider {

		constructor(el, options) {

			this.$slider = $(el);

			this.events = options.events || false;
			delete options.events;

			this.options = options;

			if (this.$slider.length) {
				this.bind();
				this.init();
			}
		}

		bind() {

			this.onResize = this.onResize.bind(this);

			$(window).on('resize', this.onResize);

			const self = this;
			if (self.events) {
				$.each(self.events, (event, callback) => {
					self.$slider.on(event, callback);
				});
			}

		}

		init() {
			this.$slider.slick(this.options);
		}

		onResize() {
			// console.log('hello');
			if (!this.$slider.hasClass('slick-initialized')) {
				this.init();
			}
		}


	}

})(jQuery);


export default slickInit;